import { defineStyle } from '@chakra-ui/react';

/** Shared overlay label for single-line controls (date picker, select, etc.). */
export const floatingLabelStyles = defineStyle({
  pos: 'absolute',
  px: '0.5',
  bg: 'bg.subtle',
  top: '2.5',
  insetStart: '3',
  fontWeight: 'normal',
  pointerEvents: 'none',
  transitionProperty: 'top, inset-inline-start, color',
  transitionDuration: 'normal',
  color: 'fg.muted',
  zIndex: 1,
  lineHeight: 'short',
  '&[data-float]': {
    top: '-3',
    insetStart: '2',
    color: 'fg',
  },
});
